var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "sc-collapse",
        {
          staticClass: "card",
          scopedSlots: _vm._u([
            {
              key: "trigger",
              fn: function(props) {
                return _c("div", {}, [
                  _c("div", { staticClass: "card-header" }, [
                    _c(
                      "strong",
                      { staticClass: "card-header-title" },
                      [
                        _c("sc-icon", {
                          staticClass: "additional-information__icon",
                          attrs: { icon: "info-circle", size: "is-small" }
                        }),
                        _vm._v("\n            Informações adicionais\n        ")
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      { staticClass: "card-header-icon" },
                      [
                        props.open
                          ? _c("sc-icon", {
                              attrs: { icon: "arrow-up", size: "is-small" }
                            })
                          : _c("sc-icon", {
                              attrs: { icon: "arrow-down", size: "is-small" }
                            })
                      ],
                      1
                    )
                  ])
                ])
              }
            }
          ])
        },
        [
          _c("div", { staticClass: "card-content" }, [
            _c("div", { staticClass: "columns" }, [
              _c(
                "div",
                { staticClass: "column is-narrow" },
                [
                  _c(
                    "sc-field",
                    { attrs: { prop: "free_shipping", label: "Frete grátis" } },
                    [
                      _c("sc-switch", {
                        model: {
                          value:
                            _vm.fields.additional_information.free_shipping,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.fields.additional_information,
                              "free_shipping",
                              $$v
                            )
                          },
                          expression:
                            "fields.additional_information.free_shipping"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "column is-narrow" },
                [
                  _c(
                    "sc-field",
                    {
                      attrs: {
                        prop: "exempt_from_icms",
                        label: "Isento de ICMS"
                      }
                    },
                    [
                      _c("sc-switch", {
                        model: {
                          value:
                            _vm.fields.additional_information.exempt_from_icms,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.fields.additional_information,
                              "exempt_from_icms",
                              $$v
                            )
                          },
                          expression:
                            "fields.additional_information.exempt_from_icms"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "column" },
                [
                  _c(
                    "sc-field",
                    {
                      attrs: {
                        prop: "extra_cost_absolute",
                        label: "Adicional no frete absoluto"
                      }
                    },
                    [
                      _c("sc-input-currency", {
                        model: {
                          value:
                            _vm.fields.additional_information
                              .extra_cost_absolute,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.fields.additional_information,
                              "extra_cost_absolute",
                              $$v
                            )
                          },
                          expression:
                            "fields.additional_information.extra_cost_absolute"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "column" },
                [
                  _c(
                    "sc-field",
                    {
                      attrs: {
                        prop: "extra_cost_percentage",
                        label: "Adicional em % do frete"
                      }
                    },
                    [
                      _c("sc-input-percent", {
                        model: {
                          value:
                            _vm.fields.additional_information
                              .extra_cost_percentage,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.fields.additional_information,
                              "extra_cost_percentage",
                              $$v
                            )
                          },
                          expression:
                            "fields.additional_information.extra_cost_percentage"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "column" },
                [
                  _c(
                    "sc-field",
                    {
                      attrs: {
                        prop: "additional_business_days",
                        label: "Dias adicionais no prazo"
                      }
                    },
                    [
                      _c("sc-decimal", {
                        attrs: {
                          placeholder: "Digite a quantidade de dias adicionais",
                          precision: 0
                        },
                        model: {
                          value:
                            _vm.fields.additional_information
                              .additional_business_days,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.fields.additional_information,
                              "additional_business_days",
                              $$v
                            )
                          },
                          expression:
                            "fields.additional_information.additional_business_days"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "columns" }, [
              _c(
                "div",
                { staticClass: "column is-narrow" },
                [
                  _c(
                    "sc-field",
                    {
                      attrs: { prop: "shipped_date", label: "Data de despacho" }
                    },
                    [
                      _c("sc-datepicker", {
                        model: {
                          value: _vm.fields.additional_information.shipped_date,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.fields.additional_information,
                              "shipped_date",
                              $$v
                            )
                          },
                          expression:
                            "fields.additional_information.shipped_date"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "column is-narrow" },
                [
                  _c(
                    "sc-field",
                    {
                      attrs: {
                        addons: true,
                        label: _vm.federalTaxPayerType(_vm.fields)
                      }
                    },
                    [
                      _c(
                        "sc-field",
                        { attrs: { prop: "federal_tax_payer_type" } },
                        [
                          _c(
                            "sc-select",
                            {
                              on: { input: _vm.changefederalTaxPayerType },
                              model: {
                                value:
                                  _vm.fields.additional_information
                                    .federal_tax_payer_type,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.fields.additional_information,
                                    "federal_tax_payer_type",
                                    $$v
                                  )
                                },
                                expression:
                                  "fields.additional_information.federal_tax_payer_type"
                              }
                            },
                            _vm._l(_vm.taxpayerListType, function(taxpayer) {
                              return _c(
                                "option",
                                {
                                  key: taxpayer.value,
                                  domProps: { value: taxpayer.value }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(taxpayer.label) +
                                      "\n                "
                                  )
                                ]
                              )
                            })
                          ),
                          _vm._v(" "),
                          _c("sc-input", {
                            directives: [
                              {
                                name: "mask",
                                rawName: "v-mask",
                                value: _vm.taxpayer.mask,
                                expression: "taxpayer.mask"
                              }
                            ],
                            key: _vm.additional_information_key,
                            attrs: { placeholder: _vm.taxpayer.placeholder },
                            model: {
                              value: _vm.fields.additional_information.taxpayer,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.fields.additional_information,
                                  "taxpayer",
                                  $$v
                                )
                              },
                              expression:
                                "fields.additional_information.taxpayer"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "column" },
                [
                  _c(
                    "sc-field",
                    {
                      attrs: { prop: "sales_channel", label: "Canal de vendas" }
                    },
                    [
                      _c("sc-input", {
                        attrs: { placeholder: "Digite o canal de vendas" },
                        model: {
                          value:
                            _vm.fields.additional_information.sales_channel,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.fields.additional_information,
                              "sales_channel",
                              $$v
                            )
                          },
                          expression:
                            "fields.additional_information.sales_channel"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "column" },
                [
                  _c(
                    "sc-field",
                    {
                      attrs: { prop: "client_type", label: "Tipo de cliente" }
                    },
                    [
                      _c("sc-input", {
                        attrs: { placeholder: "Digite o tipo de cliente" },
                        model: {
                          value: _vm.fields.additional_information.client_type,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.fields.additional_information,
                              "client_type",
                              $$v
                            )
                          },
                          expression:
                            "fields.additional_information.client_type"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.showLogistics
              ? _c("div", { staticClass: "columns" }, [
                  _c(
                    "div",
                    { staticClass: "column is-narrow" },
                    [
                      _c(
                        "sc-field",
                        { attrs: { label: "Transportadora" } },
                        [
                          _c("sc-logistic-provider-dropdown", {
                            model: {
                              value: _vm.logisticProviderId,
                              callback: function($$v) {
                                _vm.logisticProviderId = $$v
                              },
                              expression: "logisticProviderId"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "column" },
                    [
                      _c(
                        "sc-field",
                        { attrs: { label: "Métodos selecionados" } },
                        [
                          _c("sc-delivery-method-dropdown", {
                            attrs: {
                              multiple: "",
                              "logistic-provider-id": _vm.logisticProviderId
                            },
                            model: {
                              value:
                                _vm.fields.additional_information
                                  .delivery_method_ids,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.fields.additional_information,
                                  "delivery_method_ids",
                                  $$v
                                )
                              },
                              expression:
                                "fields.additional_information.delivery_method_ids"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e()
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-310757f1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-310757f1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-quote/features/freight-quote/components/sc-additional-information/ScAdditionalInformation.vue
// module id = null
// module chunks = 